import { IColorFactory } from './color-factory.interface';

const DEFAULT_BAR_COLORS = Object.freeze(['default-bar-1', 'default-bar-3', 'default-bar-2']);

export class DonutColorFactory implements IColorFactory {
  public get(index: number, _barIndexInGroup: number, _barValue: number): string {
    return DEFAULT_BAR_COLORS[index];
  }
}
